export const BLOG_REPOSITORY_OWNER = "Vishnusimha";
export const BLOG_REPOSITORY_NAME = "Blogs";
export const BLOG_REPOSITORY_BRANCH = "main";

export const BLOG_RAW_BASE_URL = `https://raw.githubusercontent.com/${BLOG_REPOSITORY_OWNER}/${BLOG_REPOSITORY_NAME}/${BLOG_REPOSITORY_BRANCH}`;
export const BLOG_INDEX_URL = `${BLOG_RAW_BASE_URL}/blog-index.json`;

export const GITHUB_PROFILE_README_URL =
  "https://raw.githubusercontent.com/Vishnusimha/Vishnusimha/main/README.md";
